<template>
  <div :class="{ hidden: hidden }" class="pagination-container">
    <el-pagination
      :background="background"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      :layout="layout"
      :page-sizes="pageSizes"
      :total="total"
      v-bind="$attrs"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import { scrollTo } from "@/utils/scroll-to";

export default {
  name: "Pagination",
  props: {
    total: {
      required: true,
      type: Number,
    },
    page: {
      type: Number,
      default: 1,
    },
    limit: {
      type: Number,
      default: 20,
    },
    pageSizes: {
      type: Array,
      default() {
        return [10, 20, 50, 100, 500, 1000, 2000, 5000];
      },
    },
    layout: {
      type: String,
      default: "total, sizes, prev, pager, next, jumper",
    },
    background: {
      type: Boolean,
      default: true,
    },
    autoScroll: {
      type: Boolean,
      default: true,
    },
    hidden: {
      type: Boolean,
      default: false,
    },

    // 分页操作后的滑动值
    scrollToNum: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    currentPage: {
      get() {
        return this.page;
      },
      set(val) {
        this.$emit("update:page", val);
      },
    },
    pageSize: {
      get() {
        return this.limit;
      },
      set(val) {
        this.$emit("update:limit", val);
      },
    },
  },
  methods: {
    handleSizeChange(val) {
      this.$emit("pagination", { page: this.currentPage, limit: val });
      if (this.autoScroll) {
        scrollTo(this.scrollToNum, 800);
      }
    },
    handleCurrentChange(val) {
      this.$emit("pagination", { page: val, limit: this.pageSize });
      if (this.autoScroll) {
        scrollTo(this.scrollToNum, 800);
      }
    },
  },
};
</script>

<style lang='scss' scoped>
.pagination-container {
  background: transparent;
  padding: 32px 16px;
}
.pagination-container.hidden {
  display: none;
}
::v-deep.pagination-container {
  .el-pagination {
    .btn-prev {
      border: none;
      background-color: #fff;
    }
    .btn-next {
      border: none;
      background-color: #fff;
    }
    .el-pager {
      li {
        border: none;
        border-radius: 5px;
        background-color: initial;
        color: #606266;
        background-color: #fff;
        font-size: 14px;
        font-weight: 400;
        &:not(.disabled, .active):hover {
          background-color: #fff;
        }
      }
      .active {
        border: none;
        background: linear-gradient(90deg, #1adc8a 0%, #23b4a0 100%) !important;
      }
    }
    .el-pagination__jump {
      .el-input__inner {
        border: none;
        background-color: #fff;
      }
    }
  }
}
</style>
